import React, { FC } from 'react';

import styles from './SwitchingTitle.module.scss';

export type SwitchingTitleType = {
    value: string;
    range: number[];
}

export interface ISwitchingTitleProps {
    titles: SwitchingTitleType[];
    percents: number;
}

export const SwitchingTitle: FC<ISwitchingTitleProps> = ({ titles, percents }) => {
    const { value } = titles.find(({ range }: SwitchingTitleType) => {
        return range[0] <= percents && range[1] >= percents;
    }) as SwitchingTitleType;

    return (
        <span className={styles.title}>
            {value}
        </span>
    )
};
